import './LoadingOverlay.css'

/**
 * LoadingOverlay Component
 * Displays a loading overlay with spinner in the bottom-right corner
 *
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the overlay
 * @param {string} props.message - Loading message to display (default: 'Loading...')
 * @param {string} props.position - Position of overlay: 'bottom-right', 'center', 'top-right' (default: 'bottom-right')
 */
const LoadingOverlay = ({
  show = false,
  message = 'Loading...',
  position = 'bottom-right'
}) => {
  if (!show) return null

  const positionClasses = {
    'bottom-right': 'loading-overlay-bottom-right',
    'center': 'loading-overlay-center',
    'top-right': 'loading-overlay-top-right',
    'bottom-left': 'loading-overlay-bottom-left',
    'top-left': 'loading-overlay-top-left',
  }

  const positionClass = positionClasses[position] || positionClasses['bottom-right']

  return (
    <div className={`loading-overlay ${positionClass}`}>
      <div className="loading-overlay-container">
        <div className="loading-overlay-spinner"></div>
        <div className="loading-overlay-text">{message}</div>
      </div>
    </div>
  )
}

export default LoadingOverlay
